<template>
  <div class="card">
    <div class="card-header cursor-pointer" @click="toggleShowBody">
      Situações e status de pedidos
      <i
        :class="
          'fa fa-lg ' +
          (showBody ? 'fa-caret-down' : 'fa-caret-up') +
          ' float-right mt-1 mr-0'
        "
      ></i>
    </div>
    <div v-if="showBody" class="card-body">
      <div class="row">

        <div
          v-for="fieldKey in fieldKeys"
          :key="fieldKey + '-order-statuses'"
          class="col-lg-6 col-12"
        >
          <div class="card">
            <div class="card-header">
              {{ fields[fieldKey].label }}
            </div>
            <div class="card-body">

              <div v-if="fieldKey === 'separation'" class="row mb-3">
                <div class="col-xl-6 col-12 mb-3 mb-xl-0">
                  <div class="row px-md-0 px-3">
                    <div class="col-auto pr-0">
                      <b-form-checkbox v-model="parameter.finishSeparationWhenOrderIsReleased"></b-form-checkbox>
                    </div>
                    <div class="col pl-0">
                      <label>Finalizar separação quando o pedido for liberado</label>
                    </div>
                    <div class="col-12">
                      <small class="text-muted">
                        Se marcado, ao sincronizar um pedido com situação "L" ele será marcado como separado no wms e counter
                      </small>
                    </div>
                  </div>
                </div>

                <div class="col-xl-6 col-12">
                  <div class="row px-md-0 px-3">
                    <div class="col-auto pr-0">
                      <b-form-checkbox v-model="parameter.cancelSeparationWhenOrderIsCancelled"></b-form-checkbox>
                    </div>
                    <div class="col pl-0">
                      <label>Habilitar cancelamento via sincronização</label>
                    </div>
                    <div class="col-12">
                      <small class="text-muted">
                        Se marcado, ao sincronizar um pedido com situação "C" ele será marcado como cancelado no WMS
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="fieldKey === 'expedition'" class="row mb-3">
                <div class="col-12">
                  <div class="row px-md-0 px-3">
                    <div class="col-auto pr-0">
                      <b-form-checkbox v-model="parameter.finishExpeditionWhenOrderIsClosed"></b-form-checkbox>
                    </div>
                    <div class="col pl-0">
                      <label>Finalizar expedição quando o pedido for fechado</label>
                    </div>
                    <div class="col-12">
                      <small class="text-muted">
                        Se marcado, ao sincronizar um pedido com situação "F" ele será marcado como "expedição finalizada" no counter
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-for="field in fields[fieldKey].fields"
                :key="field.situation + 'Field'"
                class="card"
                :id="field.situation + '-popover'"
              >
                <div class="card-header">
                  {{ field.label }}
                </div>
                <div class="card-body">
                  <div class="row px-md-0 px-3">

                    <div class="col-12 mb-3">
                      <label>Situação:</label>
                      <model-list-select
                        :list="orderStatuses"
                        option-value="value"
                        option-text="label"
                        v-model="parameter[field.situation]"
                        :filterPredicate="orderStatusFilterPredicate"
                        placeholder="Selecione a situação"
                      />
                    </div>

                    <div class="col-12">
                      <div class="row">

                        <div class="col">
                          <label>Status:</label>
                          <model-list-select
                            :list="ticketStatuses"
                            option-value="id"
                            option-text="label"
                            :value="statuses[fieldKey][field.status].status"
                            @input="onTicketStatusSelectInput($event, fieldKey, field)"
                            placeholder="Selecione o status (digite para pesquisar)"
                            @searchchange="searchTicketStatus"
                            @focus="onTicketStatusSelectFocus"
                            @click.native="onTicketStatusSelectFocus"
                            :filterPredicate="alwaysTrueFilterPredicate"
                          />
                        </div>

                        <div v-if="searchTicketStatusInProcess" class="px-5 col-auto">
                          <loading-animation />
                        </div>

                      </div>
                    </div>

                    <b-popover :target="field.situation + '-popover'" triggers="hover" placement="top">
                      {{ field.hint }}
                    </b-popover>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { LoadingAnimation } from '@/components/loaders';
  import { ModelListSelect } from 'vue-search-select'
  import { httpClient } from '@/service'

  export default {
    name: 'parameters-order-statuses',
    components: {
      LoadingAnimation,
      ModelListSelect
    },

    props: {
      parameter: {
        type: Object,
        require
      }
    },

    data() {
      return {
        showBody: true,
        orderStatuses: [
          { label: 'Nenhum', value: null },
          { label: 'A - Aberto', value: 'A' },
          { label: 'F - Fechado', value: 'F' },
          { label: 'C - Cancelado', value: 'C' },
          { label: 'CM - Cancelados', value: 'CM' },
          { label: 'P - Aguardando Liberação', value: 'P' },
          { label: 'L - Liberado', value: 'L' },
          { label: 'N - Não liberados', value: 'N' },
          { label: 'D - Autorizado Produzir', value: 'D' },
          { label: 'Z - Em Produção', value: 'Z' },
          { label: 'O - Produção Finalizada', value: 'O' },
          { label: 'T - Em Testes', value: 'T' },
          { label: 'E - Enviado', value: 'E' },
          { label: 'R - Registrado', value: 'R' },
        ],
        fields: {
          separation: {
            label: 'Separação',
            fields: [
              {
                situation: 'separationAnalysisStatus',
                status: 'analysis',
                label: 'Análise',
                hint: `Os pedidos com essa situação e/ou status vão aparecer na aba "Análise" do WMS para o gerente definir quais pedidos serão separados
                          em Romaneio (duas etapas, agrupando vários pedidos em um único) e quais serão separados individualmente (uma etapa).`
              },
              {
                situation: 'separationPendingBatchPickingStatus',
                status: 'pendingBatchPicking',
                label: 'Romaneio pendente',
                hint: `Quando for criado um Romaneio (pedidos agrupados) a situação e/ou status dos pedidos originais do Romaneio será alterada para esta até que
                          a separação do Romaneio (primeira etapa) seja concluída.`
              },
              {
                situation: 'separationPendingStatus',
                status: 'pending',
                label: 'Pendente',
                hint: `Os pedidos com essa situação e/ou status vão aparecer na aba "Pendentes" do WMS`
              },
              {
                situation: 'separationStartedStatus',
                status: 'started',
                label: 'Iniciada',
                hint: `Quando esse campo estiver preenchido, ao iniciar a separação (abrir a tela de separação do pedido) o WMS vai mudar a situação e/ou status do pedido para a configurada nesse campo.
                          Se a empresa não precisar que a situação e/ou status do pedido seja alterada após a separação ser iniciada, basta deixar esse campo em branco`
              },
              {
                situation: 'separationFinishedStatus',
                status: 'finished',
                label: 'Finalizada',
                hint: `Ao finalizar a separação o WMS irá mudar a situação e/ou status do pedido para a configurada nesse campo`
              }
            ]
          },
          expedition: {
            label: 'Expedição',
            fields: [
              {
                situation: 'expeditionToBeScheduledStatus',
                status: 'toBeScheduled',
                label: 'Aguardando agendamento',
                hint: `Os pedidos com essa situação vão aparecer na aba "Aguardando agendamento" do Counter`
              },
              {
                situation: 'expeditionFinishedStatus',
                status: 'finished',
                label: 'Finalizada',
                hint: `Ao finalizar a conferência o Counter irá mudar a situação do pedido para a configurada nesse campo`
              }
            ]
          }
        },
        ticketStatuses: [],
        searchTicketStatusInProcess: false,
        ticketStatusSearchTimeout: {},
        ticketStatusFirstLoad: true
      }
    },

    mounted() {
    },

    computed: {
      fieldKeys() {
        return Object.keys(this.fields);
      },

      statuses() {
        if (
          this.parameter &&
          this.parameter.wmsOrderFilters &&
          this.parameter.wmsOrderFilters.statuses
        ) {
          return this.parameter.wmsOrderFilters.statuses;
        }

        return {};
      }
    },

    methods: {
      toggleShowBody() {
        this.showBody = !this.showBody;
      },

      setDefault() {
        let flattenedFields = Object.values(this.fields).flatMap(group => group.fields);
        let situationKeys = flattenedFields.map(field => field.situation);

        situationKeys.forEach(key => {
          if (this.parameter[key]) {
            if (!this.parameter[key].value) {
              this.parameter[key] = this.orderStatuses.find(os => os.value === this.parameter[key]);
            }
          } else {
            this.$set(this.parameter, key, {});
          }
        });

        if (!this.parameter.wmsOrderFilters) {
          this.$set(this.parameter, 'wmsOrderFilters', {});
        }

        if (!this.parameter.wmsOrderFilters.statuses) {
          this.$set(this.parameter.wmsOrderFilters, 'statuses', {});
        }

        for (let key in this.fields) {
          if (!this.statuses[key]) {
            this.$set(this.statuses, key, {});
          }

          for (let field of this.fields[key].fields) {
            if (!this.statuses[key][field.status]) {
              this.$set(this.statuses[key], field.status, {});
            }

            if (this.statuses[key][field.status].status) {
              let id = this.statuses[key][field.status].status.id;

              if (id && !this.ticketStatuses.find(ts => ts.id === id)) {
                this.ticketStatuses.push(
                  this.statuses[key][field.status].status
                );
              }
            } else {
              this.$set(this.statuses[key][field.status], 'status', {});
            }
          }
        }

        this.handleTicketStatusList();
      },

      addSelectedTicketStatusesToList() {
        if (this.statuses) {
          for (let obj of Object.values(this.statuses)) {
            for (let field of Object.values(obj)) {
              if (
                field.status &&
                field.status.id &&
                !this.ticketStatuses.find(ts => ts.id === field.status.id)
              ) {
                this.ticketStatuses.push(field.status);
              }
            }
          }
        }
      },

      handleTicketStatusList() {
        this.addSelectedTicketStatusesToList();
        this.setTicketStatusLabel();
        this.addNoneTicketStatusOption();
      },

      orderStatusFilterPredicate(orderStatusLabel, searchText) {
        if (searchText && searchText.length) {
          if (searchText.length === 1) {
            return orderStatusLabel.substring(0, 1) === searchText.toUpperCase();
          } else {
            return orderStatusLabel.toLowerCase().includes(searchText.toLowerCase());
          }
        } else {
          return true;
        }
      },

      setTicketStatusLabel() {
        if (this.ticketStatuses && this.ticketStatuses.length) {
          this.ticketStatuses.forEach(ticketStatus => {
            if (ticketStatus.id) {
              ticketStatus.label = ticketStatus.ref + " - " + ticketStatus.description;
            }
          });
        }
      },

      addNoneTicketStatusOption() {
        if (!this.ticketStatuses.find(ts => !ts.id)) {
          this.ticketStatuses.unshift({
            id: null, label: 'Nenhum'
          });
        }
      },

      onTicketStatusSelectFocus() {
        if (this.ticketStatusFirstLoad) {
          this.searchTicketStatus();
          this.ticketStatusFirstLoad = false;
        }
      },

      onTicketStatusSelectInput(event, fieldKey, field) {
        this.statuses[fieldKey][field.status].status = {
          id: event.id,
          ref: event.ref,
          description: event.description,
          label: event.label
        };
      },

      async searchTicketStatus(searchText) {
        if (!this.searchTicketStatusInProcess && (
          (searchText && searchText.length) || this.ticketStatusFirstLoad
        )) {
          if (this.ticketStatusSearchTimeout) {
            clearTimeout(this.ticketStatusSearchTimeout);
          }

          this.ticketStatusSearchTimeout = setTimeout(() => {
            this.searchTicketStatusInProcess = true

            if (searchText && searchText.length) {
              httpClient.post(`${process.env.VUE_APP_API_URL}ticket-statuses/condition?page=${0}&size=${10}&sort=description`, {
                conditions: [
                  {
                    logicalOperator: 'OR',
                    conditions: [
                      {
                        field: 'description',
                        conditionalOperator: 'LIKE_START',
                        value: searchText
                      },{
                        field: 'ref',
                        conditionalOperator: 'LIKE_END',
                        value: searchText
                      }
                    ]
                  }
                ]
              })
              .then(({ data }) => {
                this.searchTicketStatusInProcess = false
                this.ticketStatuses = data.data.content
                this.handleTicketStatusList();
              })
              .catch((error) => {
                this.searchTicketStatusInProcess = false
                if (error.message) {
                  this.$notify.error(error)
                }
              });
            } else {
              httpClient.get(`${process.env.VUE_APP_API_URL}ticket-statuses/?page=${0}&size=${10}&sort=description`)
              .then(({ data }) => {
                this.searchTicketStatusInProcess = false
                this.ticketStatuses = data.data.content
                this.handleTicketStatusList();
              })
              .catch((error) => {
                this.searchTicketStatusInProcess = false
                if (error.message) {
                  this.$notify.error(error)
                }
              });
            }
          }, 500);
        }
      },

      alwaysTrueFilterPredicate() {
        return true;
      }
    },

    watch: {
      parameter: {
        immediate: true,
        handler(newValue, oldValue) {
          this.setDefault();
        }
      }
    }
  }
</script>

<style scoped>
</style>
